import React from 'react'
import { Courses } from '../../component/education/Courses'

export default function EducationPage() {
  return (
    <>
      <Courses />
    </>
  )
}
